var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C5.6 4 1.3 11.8.2 14.3a1.95 1.95 0 0 0 0 1.5C1.3 18.2 5.6 26 15 26s13.7-7.9 14.8-10.3a1.95 1.95 0 0 0 0-1.5C28.7 11.8 24.4 4 15 4zm14 11-.2.3c-1 2.3-5.1 9.7-13.9 9.7C6.2 25 2.1 17.6 1 15.4V15l.2-.3C2.2 12.4 6.2 5 15 5c8.7 0 12.8 7.4 13.9 9.7zM9.2 15A5.8 5.8 0 1 0 15 9.2 5.8 5.8 0 0 0 9.2 15zm5.8-4.7a4.7 4.7 0 1 1-4.7 4.7 4.695 4.695 0 0 1 4.7-4.7zM6.2 30H0v-6.2h1V29h5.2zM23.8 0H30v6.2h-1V1h-5.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.1268e961c40cb0a31d396be09300d1b8.svg";
export { ForwardRef as ReactComponent };